<template>
  <div class="content self_c">
    <headNav
      :flag="true"
      title=" "
    />
    <!-- :back="true" -->
    <div
      class="cell-content body self_b"
      :style="'min-height:' + window_.body_h + 'px;'"
    >
      <p
        class="cell-title self_cell-title"
        slot="title"
      >
        {{ window_c["Please ent this following information"] }}
      </p>
      <van-cell-group>
        <p
          class="cell-desc"
          slot="title"
        >{{ window_c["Account name"] }}</p>
        <div class="item1">
          <div class="item1_inp self_line">
            <van-field
              v-model="requestParams.memberName"
              :placeholder="window_c['Enter you account name']"
            />
          </div>
          <div
            class="self_item_1 self_line"
            @click="sex_.show = true"
          >
            {{ sex_.selectT }}
            <img src="../assets/icon/icn-back-white.png" />
          </div>
        </div>
      </van-cell-group>
      <van-cell-group>
        <p
          class="cell-desc"
          slot="title"
        >{{ window_c["Your birthday"] }}</p>
        <div
          class="self_item_1 self_line"
          style="padding-right: 15px;"
          @click="bor_day.show = true"
          :style="requestParams.birthday ? 'color:#000;' : ''"
        >
          <!-- <van-field v-model="requestParams.birthday"  disabled :placeholder="window_c['Enter your birthday']" /> -->
          <div class="self_cell">
            {{ requestParams.birthday }}
            <div
              class="self_cell_place"
              v-if="!requestParams.birthday"
            >
              {{ window_c["Enter your birthday"] }}
            </div>
          </div>
          <img
            style="align-self: center;"
            src="../assets/icon/icn-back-white.png"
          />
        </div>
      </van-cell-group>
      <van-cell-group>
        <p
          class="cell-desc"
          slot="title"
        >{{ window_c["Email"] }}</p>
        <div class="self_item_1 self_line">
          <van-field
            v-model="requestParams.email"
            :placeholder="window_c['Enter your Email']"
          />
        </div>
      </van-cell-group>

      <!-- <div class="nogo" @click="nogoClick">{{ window_c['Skip'] }}</div> -->
      <div class="cell-button">
        <p
          @click="nextClick"
          :style="
            !requestParams.memberName ||
            requestParams.sex === '' ||
            !requestParams.birthday ||
            !requestParams.email
              ? 'background-color:#ccc;'
              : ''
          "
        >
          {{ window_c["Done"] }}
        </p>
      </div>

      <van-action-sheet
        v-model="sex_.show"
        :actions="sex_.actions"
        @select="onSelect"
        class="self_sex_box"
      />

      <van-action-sheet
        v-model="bor_day.show"
        :title="window_c['Choosing birthday']"
        class="self_birthday_box"
      >
        <van-datetime-picker
          v-model="bor_day.currentDate"
          :confirm-button-text="window_c['confirm']"
          :cancel-button-text="window_c['cancel']"
          @confirm="borConfirm"
          @cancel="borCancel"
          :max-date="bor_day.maxDate"
          :min-date="bor_day.minDate"
          type="date"
        />
      </van-action-sheet>
    </div>
  </div>
</template>

<script>
import headNav from "@/components/headNav";
import util from "@/js/util";
import { updateInfo, registerOthNew, joinBrand, smsLogin, updataOth } from "@/js/api";
import lang_ from "@/js/locales";
export default {
  data () {
    return {
      window_: {
        bodyh: 0
      },
      window_c: {
        "Please ent this following information": "點稱呼你呢?",
        "Account name": "用戶名稱",
        "Enter you account name": "請填寫你的用戶名稱",
        Mr: "性別",
        "Choose your gender": "選擇你的性別",
        "Your birthday": "生日日期",
        "Enter your birthday": "請填寫你的生日日期",
        Email: "Email",
        "Enter your Email": "請填寫你的Email賬號",
        "Incorrect mailbox format": "郵箱格式不正確",
        Skip: "略過",
        Done: "下一步",
        male: "男",
        female: "女",
        secrecy: "保密",
        "Choosing birthday": "選擇生日",
        confirm: "確認",
        cancel: "取消",
        Loading: "加載中...",
        "Warm reminder": "溫馨提示",
        "With changing your birthday, you will not be eligible for Birthday Offer in 365 days.Proceed?":
          "如果更改您的生日，您将无法在365天内获得生日优惠。是否继续？"
      },
      value: "123",

      sex_: {
        show: false,
        actions: [{ name: "男" }, { name: "女" }],
        selectT: "性別"
      },
      bor_day: {
        show: false,
        currentDate: new Date(),
        maxDate: new Date(),
        minDate: new Date("1900/01/01")
      },
      requestParams: {
        memberName: "", //暱稱
        email: "", //郵箱
        birthday: "", //生日
        sex: "", //性別 2:女 1：男 其他：保密
        disName: "",
        proName: "",
        memberId: 0, //用戶id 必傳
        check: 1 //默認為1
      },
      registerData: {},
      userInfo: []
    };
  },
  created () {
    util.selfSetIcon(); // 設置logo
    util.getBrand(this);
    let J = util.getWindowInner(),
      w = J.w,
      h = J.h;
    this.window_.body_h = h - 46;
    let userinfo = util.userInfo.get(this)
    if (userinfo) {
      this.userInfo = JSON.parse(userinfo);
      this.requestParams.memberId = this.userInfo.memberId;
    }
  },
  mounted () {
    this.init_lang();
    this.init_window();
  },
  methods: {
    init_lang () {
      var window_c = this.window_c;
      window_c["Please ent this following information"] = lang_.t(
        "Please ent this following information"
      );
      window_c["Account name"] = lang_.t("Account name");
      window_c["Enter you account name"] = lang_.t("Enter you account name");
      window_c["Mr"] = lang_.t("Mr");
      window_c["Choose your gender"] = lang_.t("Choose your gender");
      window_c["Your birthday"] = lang_.t("Your birthday");
      window_c["Enter your birthday"] = lang_.t("Enter your birthday");
      window_c["Email"] = lang_.t("Email");
      window_c["Enter your Email"] = lang_.t("Enter your Email");
      window_c["Incorrect mailbox format"] = lang_.t(
        "Incorrect mailbox format"
      );
      window_c["Skip"] = lang_.t("Skip");
      window_c["Done"] = lang_.t("Done");
      window_c["Choosing birthday"] = lang_.t("Choosing birthday");
      window_c["confirm"] = lang_.t("confirm");
      window_c["cancel"] = lang_.t("cancel");
      window_c["Loading"] = lang_.t("Loading");
      window_c["Warm reminder"] = lang_.t("Warm reminder");
      window_c[
        "With changing your birthday, you will not be eligible for Birthday Offer in 365 days.Proceed?"
      ] = lang_.t(
        "With changing your birthday, you will not be eligible for Birthday Offer in 365 days.Proceed?"
      );
      this.sex_.selectT = lang_.t("Mr");
      this.sex_.actions[0].name = lang_.t("male");
      this.sex_.actions[1].name = lang_.t("female");
      // this.sex_.actions[2].name = lang_.t('secrecy');
    },
    init_window () {
      return; // 不填充數據
    },
    onSelect (item) {
      // 默认情况下，点击选项时不会自动关闭菜单
      // 可以通过 close-on-click-action 属性开启自动关闭
      this.sex_.show = false;
      this.sex_.selectT = item.name;
      if (item.name == this.sex_.actions[0].name) {
        this.requestParams.sex = 1;
      } else if (item.name == this.sex_.actions[1].name) {
        this.requestParams.sex = 2;
      } else {
        this.requestParams.sex = 0;
      }
    },
    borConfirm (e) {
      var date = util.getDate(e);
      this.requestParams.birthday = date;
      this.bor_day.show = false;
    },
    borCancel () {
      this.bor_day.show = false;
    },
    nogoClick () {
      this.$router.replace({
        name: "vipCard",
        params: {
          arg: util.setQueryParams(util.getBrandId(this))
        }
      });
    },
    nextClick () {
      var self = this;
      // 校驗
      if (!self.requestParams.memberName) {
        self.$toast(self.window_c["Enter you account name"]);
      } else if (!self.requestParams.birthday) {
        self.$toast(self.window_c["Enter your birthday"]);
      } else if (self.requestParams.sex === "") {
        self.$toast(self.window_c["Choose your gender"]);
      } else if (!self.requestParams.email) {
        self.$toast(self.window_c["Enter your Email"]);
      } else if (!util.ISEMAIL(self.requestParams.email)) {
        self.$toast(self.window_c["Incorrect mailbox format"]);
      } else {
        this.registerOthNew();
      }
    },
    // 註冊
    registerOthNew () {
      let registerDataStr = JSON.parse(
        sessionStorage.getItem("food-story-register-data")
      );
      this.registerData = registerDataStr;
      let params = {
        phone: registerDataStr.phone,
        password: registerDataStr.password,
        countryId: registerDataStr.countryId,
        code: registerDataStr.code,
        birthday: this.requestParams.birthday,
        memberName: this.requestParams.memberName,
        email: this.requestParams.email,
        sex: this.requestParams.sex,
      };
      registerOthNew(params)
        .then(res => {
          if (res.success) {
            this.joinBrand(res.data.memberInfo);
          } else {
            if (res.errCode == "SMS.0001") {
              this.errorFun();
            } else if (res.errCode == "LOGIN.0020") {
              this.$toast("會員登錄錯誤次數太多,請稍後重試!");
            } else if (res.errCode == "LOGIN.0005") {
              this.$toast("帳戶已暫停，請聯絡客戶服務email!");
            } else if (res.errCode == "LOGIN.0006") {
              this.$toast("帳戶已過期，請聯絡客戶服務email!");
            } else if (res.errCode == "REGISTERED.0002") {
              // 去修改信息
              this.smsLogin();
            } else {
              this.$toast(res.errMsg);
            }
          }
        })
        .catch(err => { });
    },
    // 通過短信 拿取用戶信息
    smsLogin () {
      let registerDataStr = JSON.parse(
        sessionStorage.getItem("food-story-register-data")
      );
      let params = {
        phone: registerDataStr.phone,
        countryId: registerDataStr.countryId,
        code: registerDataStr.code,
      };
      smsLogin({
        phone: params.phone,
        code: params.code,
        countryId: params.countryId
      }).then(res => {
        if (res.success) {
          let memberInfo = res.data.memberInfo;
          this.updateMemberInfo(memberInfo)
        } else {
          this.errorFun();
        }
      }).catch(err => {
        this.errorFun();
      })
    },

    // 修改 其他信息
    updateInfo (memberInfo) {
      updateInfo({
        memberId: memberInfo.id,
        liveAddress: this.requestParams.liveAddress,
        workAddress: this.requestParams.workAddress,
        ageGroup: this.requestParams.ageGroup,
      }).then(res => {
        if (res.success) {
          this.joinBrand(memberInfo);
        } else {
          this.errorFun();
        }
      }).catch(err => {
        this.errorFun();
      })
    },
    // 修改用戶信息
    updateMemberInfo (memberInfo) {
      let params = {
        id: memberInfo.id,
        memberName: this.requestParams.memberName,
        birthday: this.requestParams.birthday,
        email: this.requestParams.email,
        sex: this.requestParams.sex,
        password: this.registerData.password,
      };
      updataOth(params).then(res => {
        if (res.success) {
          // 修改成功
          this.updateInfo(memberInfo);
        } else {
          this.errorFun();
        }
      }).catch(err => {
        this.errorFun();
      })
    },
    // 成功
    successFun (memberInfo) {
      sessionStorage.removeItem("food-story-register-data");
      let userInfo = {};
      userInfo.memberName = this.requestParams.memberName;
      userInfo.sex = this.requestParams.sex;
      userInfo.email = this.requestParams.email;
      userInfo.birthday = this.requestParams.birthday;
      userInfo.memberId = memberInfo.id;
      userInfo.phone = memberInfo.phone;
      userInfo.countryId = memberInfo.countryId;
      util.userInfo.set(this, userInfo);
      this.$toast.success({
        message: lang_.t("Registration success"),
        duration: 1000,
        onClose: () => {
          // 1 表示 返回登錄或退出登錄信息
          // 0 表示 不返回
          this.$router.replace({
            name: "vipCard",
            params: {
              arg: util.setQueryParams(util.getBrandId(this, 1))
            }
          });
        }
      });
    },
    // 註冊失敗
    errorFun () {
      // console.log(11,'失败');
      sessionStorage.removeItem("food-story-register-data");
      this.$toast({
        message: "註冊信息已過期,請重新註冊!",
        onClose: () => {
          // 返回註冊
          this.$router.replace({
            name: "register",
            params: {
              arg: util.setQueryParams(util.getBrandId(this, 1))
            }
          });
        }
      });
    },
    // 加入品牌
    joinBrand (memberInfo) {
      joinBrand({
        memberId: memberInfo.id,
        phone: memberInfo.phone,
        brandId: util.getBrandId(this, 1),
        invitationCode: localStorage.getItem("recommendationCode") || ""
      })
        .then(res => {
          localStorage.removeItem("recommendationCode");
          if (res.code == 1) {
          }
          this.successFun(memberInfo);
        })
        .catch(err => {
          this.errorFun();
        });
    },
    checkBirthday (msg) {
      var self = this;
      // self.$dialog
      // 	.confirm({
      // 		title: self.window_c['Warm reminder'],
      // 		message: self.window_c['With changing your birthday, you will not be eligible for Birthday Offer in 365 days.Proceed?'],
      // 		confirmButtonText: self.window_c['cancel'],
      // 		cancelButtonText: self.window_c['confirm'],
      // 		cancelButtonColor: '#56AC9A',
      // 		confirmButtonColor: '#222'
      // 	})
      // 	.then(() => {
      // 		// on confirm
      // 	})
      // 	.catch(() => {
      // 		// on cancel
      // 		var req = self.requestParams;
      // 		delete req.check;
      // 		this.requestParams = req;
      // 		self.nextClick();
      // 	});
      //  靜默 修改  不彈窗
      var req = self.requestParams;
      delete req.check;
      this.requestParams = req;
      self.nextClick();
    }
  },
  components: {
    headNav
  }
};
</script>

<style scoped>
.content {
  background-color: #fff;
}

.body {
  display: flex;
  flex-direction: column;
}

[class*="van-hairline"]:after {
  border: none;
}
.cell-title {
  font-size: 60px;
  color: #000;
  margin: 6.667vw 0;
  line-height: initial;
  /* margin: ; */
}
.self_cell-title {
  padding-left: 16px;
}
.cell-desc {
  font-size: 26px;
  color: #222;
}

.item1 {
  display: flex;
}

.item1 img {
  width: 50px;
  height: 50px;
}

.item1_inp {
  min-width: 70%;
}

.self_item_1 {
  display: flex;
  align-items: center;
  padding: 0 15px;
  min-width: 30%;
  justify-content: space-between;
}

.self_line {
  position: relative;
}
.self_line:after {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: 15px;
  bottom: 0;
  left: 15px;
  border-bottom: 1px solid #ebedf0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}

.self_item_1 img {
  width: 25px;
  height: 25px;
}

.nogo {
  color: #969799;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: auto;
}

.cell-button p {
  width: calc(100% - 20px);
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #5abba7;
  color: #fff;
  border-radius: 8px;
  margin: 0 auto;
  font-size: 17px;
  margin-top: 50px;
  margin-bottom: 50px;
}

.self_cell {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 16px 10px 0;
  overflow: hidden;
  color: #323233;
  font-size: 14px;
  line-height: 24px;
  background-color: #fff;
}
.self_cell_place {
  color: rgb(214, 212, 212);
}

.cell-button {
  margin-top: auto;
}

.self_item_1 .van-cell {
  padding-left: 0;
}

.pc_content .self_birthday_box,
.pc_content .self_sex_box {
  position: absolute !important;
}
</style>



// WEBPACK FOOTER //
// src/view/information.vue